import { createSlice } from '@reduxjs/toolkit'
import { OrderStatus, Status } from 'models/OrderStatus'
import { finalizeOrder } from 'redux/thunks/order/finalizeOrder'
import { PayloadAction } from '@reduxjs/toolkit'

const initialState: Status = { status: OrderStatus.IDLE, error: null }

export const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<{ status: OrderStatus; error?: string | null }>) => {
      state.status = action.payload.status
      state.error = action.payload.error ?? null
    },
    resetStatus: (state) => {
      if (state.status === OrderStatus.FAILED) {
        state.status = OrderStatus.IDLE
        state.error = null
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(finalizeOrder.pending, (state) => {
        state.status = OrderStatus.PROCESSING
        state.error = null
      })
      .addCase(finalizeOrder.fulfilled, (state) => {
        state.status = OrderStatus.SUCCEEDED
        state.error = null
      })
      .addCase(finalizeOrder.rejected, (state, action) => {
        state.status = OrderStatus.FAILED

        state.error =
          action.error.message ?? 'An error has occurred while trying to finalize your payment.'
      })
  },
})

export const { setStatus, resetStatus } = statusSlice.actions

// Export the reducer
export default statusSlice.reducer
